import React from 'react';

interface PlaceholderImageProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({ src, alt, className, style }) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.currentTarget;
    target.src = `data:image/svg+xml;base64,${btoa(`
      <svg width="400" height="300" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#f5f5f7"/>
        <text x="50%" y="50%" font-family="Arial" font-size="16" fill="#86868b" text-anchor="middle" dy="0.35em">
          ${alt}
        </text>
      </svg>
    `)}`;
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={handleError}
    />
  );
};

export default PlaceholderImage;
